import React from 'react';
import {
  coerceDataGridAnswerValue,
  dataGridColumns,
} from '../../../utils/dataGridAnswerDisplay';

/**
 * Read-only data grid table — matches ApplicationQuestionField layout for DATA_GRID / COMPARISON_TABLE.
 */
export default function DataGridAnswerTable({ question, value, compact = false }) {
  const cols = dataGridColumns(question, value);
  const rows = coerceDataGridAnswerValue(value, question);
  const cellPad = compact ? 'px-1 py-0.5' : 'px-2 py-1';
  const textSize = compact ? 'text-xs' : 'text-sm';
  const filledRows = rows.filter((row) =>
    cols.some((c) => row?.[c.key] != null && String(row[c.key]).trim() !== '')
  );
  const displayRows = filledRows.length ? filledRows : (rows.length ? [rows[0]] : []);

  return (
    <div className="overflow-x-auto">
      <table className={`w-full border-collapse ${textSize} border border-gray-300`}>
        <thead>
          <tr className="bg-gray-50">
            {cols.map((c) => (
              <th key={c.key} className={`border border-gray-300 ${cellPad} text-left font-medium text-gray-800`}>
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {displayRows.map((row, ri) => (
            <tr key={ri}>
              {cols.map((c) => {
                const cell = row?.[c.key];
                const shown = cell != null && String(cell).trim() ? String(cell).trim() : null;
                return (
                  <td key={c.key} className={`border border-gray-300 ${cellPad} text-gray-900`}>
                    {shown || <span className="text-gray-400">—</span>}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
